import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { MessageService } from 'primeng/api';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ContactGroupService } from 'src/app/private/services/contact-group.service';
import { CreateContactGroupComponent } from "../../components/contact-group/create-contact-group/create-contact-group.component";
import { ContactGroupListComponent } from "../../components/contact-group/contact-group-list/contact-group-list.component";
import { AddContactInGroupComponent } from "../../components/contact-group/add-contact-in-group/add-contact-in-group.component";
import { BulkImportContactComponent } from "../../components/contact-group/bulk-import-contact/bulk-import-contact.component";

@Component({
  selector: 'app-contact-group',
  imports: [ToolBarComponent, SharedModule, CreateContactGroupComponent, ContactGroupListComponent, AddContactInGroupComponent, BulkImportContactComponent],
  templateUrl: './contact-group.component.html',
  styleUrl: './contact-group.component.scss'
})
export class ContactGroupComponent {

  initalLoadGroup: boolean = true;
  isAddGroup: boolean = false;
  isEditGroup: boolean = false;
  isDeleteGroup: boolean = false;

  isAddContact: boolean = false;
  isImportContact: boolean = false;

  initialLoad: boolean = true;
  currentSelectedContactGroupID: any;


  allContactGroups: any;

  dataToEdit: any;

  btnLoading: boolean = false;

  toggleFlag: boolean = false;


  preSelectedLeadIds: any[] = [];
  preSelectedContactIds: any[] = [];

  menuItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Add Contacts',
          icon: 'pi pi-fw pi-plus',
          command: () => {
            this.isAddContact = true;
          }
        },
        {
          label: 'Import Contacts',
          icon: 'pi pi-fw pi-upload',
          command: () => {
            this.isImportContact = true;
          }
        },
        {
          label: 'Edit Group',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditGroup = true;
          }
        },
        {
          label: 'Delete Group',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteGroup = true;
          }
        }
      ]
    }
  ];

  constructor(
    private api: ContactGroupService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.getAllContactGroups();
  }

  getAllContactGroups(type?: string) {

    const payload = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "contact_group_type": "Email"
      },
      "filter": null,
      "page": 0,
      "limit": 10,
      "order": {
        "col": "\"contact_group\".\"createdAt\"",
        "dir": "DESC"
      }
    }

    this.api.getAllContactGroups(payload).subscribe(
      (res) => {
        this.allContactGroups = res;

        this.initalLoadGroup = false;

        if (this.currentSelectedContactGroupID === undefined || this.currentSelectedContactGroupID === null ||
          this.currentSelectedContactGroupID === '') {
          this.currentSelectedContactGroupID = this.allContactGroups?.[0]?.id;
        }


        this.initialLoad = false;


        if (type === 'Create') {
          this.isAddGroup = false;
          this.toggleFlag = !this.toggleFlag;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact Group Created Successfully' });
        }

        if (type === 'Edit') {
          this.isEditGroup = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact Group Updated Successfully' });
        }

        if (type === 'Delete') {
          // this.modalService.dismissAll();
          this.isDeleteGroup = false;
          this.btnLoading = false;
          this.currentSelectedContactGroupID = this.allContactGroups?.[0]?.id;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact Group Deleted Successfully' });
          // this.toast.success("Contact Group Deleted Successfully");
        }

        if (type == 'Bulk Add') {
          this.toggleFlag = !this.toggleFlag;
          this.isAddContact = false;
          this.isImportContact = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contacts Added Successfully' });
        }
      },
      (err) => {
        console.error(err);
      }
    )
  }

  reloadContactGroup(type?: string) {
    this.getAllContactGroups(type);
  }

  reloadListData() {
    this.toggleFlag = !this.toggleFlag;
  }

  handleChangeGroup(item: any) {

    this.dataToEdit = item;
    if (this.currentSelectedContactGroupID === item.id) {
      return;
    }

    // this.isRefresh = true;
    // if (this.contactGroupListComponent) {
    //   this.contactGroupListComponent.resetPaginator();
    // }
    // this.currentPage = 0;
    // this.pageSize = 10;
    this.currentSelectedContactGroupID = item.id;
    // this.loadData();
  }

  handleDelete() {

    const payload = {
      "id": this.dataToEdit.id
    }

    this.btnLoading = true;

    this.api.deleteContactGroup(payload).subscribe(
      (res: any) => {
        this.getAllContactGroups('Delete');
      },
      (err: any) => {
        console.error(err);
      }
    )
  }

  handleUpdatePreData(event: { leadIds: any[]; contactIds: any[] }) {
    console.log('Received pre-selected data:', event);
    this.preSelectedLeadIds = event.leadIds;
    this.preSelectedContactIds = event.contactIds;
  }

}
